/* eslint-disable class-methods-use-this */
class PrinterNav {
  constructor(printer, qzConnection, $container) {
    this.printer = printer;
    this.navigation = $container.find("#printer-nav");
    this.setOSTab(printer, $container);
    this.enableTestTab(printer, $container);
    this.bindEvents($container);
  }

  bindEvents($container) {
    var self = this;

    $container.on("click", ".js-next-btn", function(e) {
      $container.find(".nav-link, .tab-pane").removeClass("active");
      self.setActiveTab($(e.target).data("tab"));
    });

    this.navigation.on("update", function(_e) {
      self.enableTestTab();
    });

    $("#install-tab").on("shown.bs.tab", function(_e) {
      self.setOSTab();
    });
  }

  setOSTab(printer, $container) {
    var os = printer.isMac ? "mac" : "windows";

    $container.find(".js-os-tabs")
      .find("a[href='#" + os + "']")
      .addClass("active");

    $container.find(".js-os-tab-content")
      .find("#" + os)
      .addClass("active");
  }

  setActiveTab(tab) {
    $(tab).tab("show");
  }

  enableTestTab() {
    var testTab = this.navigation.find("#test-tab");

    if (this.printer.name.length) {
      setTimeout(function() {
        testTab.removeClass("disabled");
        $(".js-test-tab-tooltip").tooltip("dispose");
        $(".js-test-tab-btn").removeClass("disabled");
      }, 50);
    }
  }
}

export { PrinterNav };
